export default () => ({
  signupSession: false,
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  birthdate: '',

  country: {
    name: '',
    code: ''
  },
  state: {
    name: '',
    code: '',
    country: ''
  },
  streetName: '',
  city: '',
  zipCode: '',

  acceptsTerms: false,
  acceptsPrivacy: false,

  divisions: [],

  stripeClientSecret: '',

  guardianFirstName: '',
  guardianLastName: '',
  guardianEmail: '',
  guardianConsent: false,
  guardianVideoConsent: false
})
